import React from 'react';
import { FaInfo } from 'react-icons/fa';
import Dropdown from 'react-bootstrap/Dropdown';

import { useAppSelector } from '../../../app/hooks';
import { selectMemberActionById } from '../memberSlice';
import { hasAnyAction } from '../../../common/has-any-action';

type Props = {
  id: string;
  onClickEnable?: () => void;
  onClickDisable?: () => void;
  onClickEdit?: () => void;
  onClickView?: () => void;
  onClickDelete?: () => void;
};

export function MemberToolButton(props: Props) {
  let action = useAppSelector((state) => selectMemberActionById(state, props.id));
  let has_any_action = hasAnyAction(action);
  if (!has_any_action) {
    return <React.Fragment/>;
  }
  return (
    <Dropdown>
      <Dropdown.Toggle variant="dark">
        <FaInfo/>
      </Dropdown.Toggle>
      <Dropdown.Menu>
        { action.can_enable && 
        <Dropdown.Item onClick={props.onClickEnable}>Enable</Dropdown.Item>
        }
        { action.can_disable &&
        <Dropdown.Item onClick={props.onClickDisable}>Disable</Dropdown.Item>
        }
        { action.can_edit &&
        <Dropdown.Item onClick={props.onClickEdit}>Edit</Dropdown.Item>
        }
        { action.can_view &&
        <Dropdown.Item onClick={props.onClickView}>View</Dropdown.Item>
        }
        { action.can_delete &&
        <Dropdown.Item onClick={props.onClickDelete}>Delete</Dropdown.Item>
        }
      </Dropdown.Menu>
    </Dropdown>
  );
}
